import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement } from 'react';
export function ButtonGroup({ children, size, className }) {
    const items = Children.toArray(children).filter((child) => isValidElement(child));
    const count = items.length;
    return (_jsx("div", { role: "group", className: `inline-flex ${className ?? ''}`, children: items.map((child, index) => {
            let borderRadius;
            if (count === 1) {
                borderRadius = 'var(--sam-radius-sm)';
            }
            else if (index === 0) {
                borderRadius = 'var(--sam-radius-sm) 0 0 var(--sam-radius-sm)';
            }
            else if (index === count - 1) {
                borderRadius = '0 var(--sam-radius-sm) var(--sam-radius-sm) 0';
            }
            else {
                borderRadius = '0';
            }
            const extraStyle = {
                borderRadius,
                ...(index > 0 ? { marginLeft: -1 } : {}),
            };
            return cloneElement(child, {
                ...(size ? { size } : {}),
                style: { ...(child.props.style ?? {}), ...extraStyle },
            });
        }) }));
}
//# sourceMappingURL=ButtonGroup.js.map